<app-header>
  @if (!disableSend()) {
    <div class="bv-new-send-menu">
      <tools-new-send-dropdown [hideIcon]="true"></tools-new-send-dropdown>
    </div>
  }
</app-header>

@if (disableSend()) {
  <bit-callout type="warning" title="{{ 'sendDisabled' | i18n }}">
    {{ "sendDisabledWarning" | i18n }}
  </bit-callout>
}

<div class="bv-listing-page tw-flex tw-flex-row -tw-mx-2.5">
  <div
    class="bv-listing-page__column tw-px-2.5"
    [class.tw-basis-3/4]="allowedSendTypes().length !== 1"
    [class.tw-max-w-3/4]="allowedSendTypes().length !== 1"
    [class.tw-basis-full]="allowedSendTypes().length === 1"
    [class.tw-max-w-full]="allowedSendTypes().length === 1"
  >
    <div class="bv-sends-listing">
      <div class="bv-sends-listing__header">
        <h2 class="bv-sends-listing__title">{{ "allSends" | i18n }}</h2>
        <bit-search
          class="bv-sends-listing__search"
          id="sends-listing-search"
          placeholder="{{ 'search' | i18n }}"
          [ngModel]="currentSearchText()"
          (ngModelChange)="searchTextChanged($event)"
          autocomplete="off"
        />
      </div>

      <tools-send-list
        [sends]="filteredSends()"
        [loading]="loading()"
        [disableSend]="disableSend()"
        [listState]="listState()"
        [searchText]="currentSearchText()"
        [hideSearchBar]="true"
        (editSend)="editSend($event)"
        (copySend)="onCopySend($event)"
        (deleteSend)="deleteSend($event)"
        (removePassword)="onRemovePassword($event)"
      >
      </tools-send-list>
    </div>
  </div>

  @if (allowedSendTypes().length !== 1) {
    <div class="bv-listing-page__column tw-basis-1/4 tw-max-w-1/4 tw-px-2.5">
      <app-send-filters
        [selected]="selectedToggleValue"
        (selectedChange)="onToggleChange($event)"
      ></app-send-filters>
    </div>
  }
</div>
